var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.$route.query.redirect)?_c('div',{staticClass:"pl-2 text-h4"},[_vm._v(" "+_vm._s(_vm.$t("login-view-title"))+" ")]):_vm._e(),_c('Login',{attrs:{"queryParams":_vm.$route.query}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }